import React from "react";
import "./Testing.css";
import ParentLayout from "../../layouts/ParentLayout";
import ProfileHero from "../../components/Profile/ProfileHero";

const Testing = () => {


  
  return (
      <ParentLayout>
      <div className="mt-10">
        <ProfileHero />
          </div>
    </ParentLayout>
  );
};

export default Testing;
